export const SERVER_URL ="https://cors-anywhere.herokuapp.com/http://3.22.166.66:8082"
export const PRODUCT_URL ='http://localhost:3001/'
// export const SERVER_URL ="https://api.bookn.de/v1"
// export const PRODUCT_URL ='https://api.bookn.de/'
